<nav
  style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E&#34;);background-color: white;"
  aria-label="breadcrumb">
  <ol class="breadcrumb" style="background-color: white;">
    <li class="breadcrumb-item"><a href="https://bancodeoccidente.com.co">Inicio</a></li>
    <li class="breadcrumb-item active" aria-current="page">Garantías</li>
  </ol>
</nav>

<h1 style="color: #2e8bcc">Garantías</h1>

<h3>Verifica la validez, idioneidad y suficiencia de los documentos que se entregan como soporte de las garantías emitidas.</h3>

<h3>Por favor diligencie los siguientes campos:</h3>

<form name="form-garantia" [formGroup]="form" autocomplete="off">

  <div class="row">
    <div class="col-md-4 form-group">
      <mat-form-field class="example-full-width">
        <mat-label>Nombre</mat-label>
        <input matInput [(ngModel)]="consultaGarantia.nombre" name="nombre" formControlName="vNombre" minlength="1"
          maxlength="75" type="text" placeholder="Nombre" required>
          @if (f.vNombre.invalid) {
            <mat-error>
              @if (f.vNombre.hasError('required')) {
                <div>
                  {{'El campo Nombre es requerido'}}
                </div>
              }
              @if (f.vNombre.hasError('pattern')) {
                <div>
                  {{'El campo Nombre no permite caracteres especiales'}}
                </div>
              }
              @if (f.vNombre.hasError('minlength')) {
                <div>
                  {{'El campo debe tener mínimo 1 carácter'}}
                </div>
              }
              @if (f.vNombre.hasError('maxlength')) {
                <div>
                  {{'El campo debe tener máximo 75 carácteres'}}
                </div>
              }
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-md-4 form-group">
        <mat-form-field class="example-full-width">
          <mat-label>Tipo de Identificación *</mat-label>
          <mat-select [(ngModel)]="consultaGarantia.tipoIdentificacion" name="tipoIdentificacion"
            formControlName="vTipoIdentificacion" requared>
            <mat-option>None</mat-option>
            @for (item of select; track item) {
              <mat-option value="{{item.type}}">{{item.name}}</mat-option>
            }
          </mat-select>
          @if (f.vTipoIdentificacion.invalid) {
            <mat-error>
              @if (f.vTipoIdentificacion.hasError('required')) {
                <div>
                  {{'El campo Tipo de Identificación es requerido'}}
                </div>
              }
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-md-4 form-group">
        <mat-form-field class="example-full-width">
          <mat-label>Número de Identificación</mat-label>
          <input matInput [(ngModel)]="consultaGarantia.numeroIdentificacion" name="numeroIdentificacion"
            formControlName="vNumeroIdentificacion" minlength="3" maxlength="11" type="text"
            placeholder="Número de Identificación" required>
            @if (f.vNumeroIdentificacion.invalid) {
              <mat-error>
                @if (f.vNumeroIdentificacion.hasError('pattern')) {
                  <div>
                    {{'El campo Número de Identificación debe ser un número'}}
                  </div>
                }
                @if (f.vNumeroIdentificacion.hasError('required')) {
                  <div>
                    {{'El campo Número de Identificación es requerido'}}
                  </div>
                }
                @if (f.vNumeroIdentificacion.hasError('minlength')) {
                  <div>
                    {{'El campo debe tener mínimo 3 carácteres'}}
                  </div>
                }
                @if (f.vNumeroIdentificacion.hasError('maxlength')) {
                  <div>
                    {{'El campo debe tener máximo 11 carácter'}}
                  </div>
                }
              </mat-error>
            }

          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 form-group">
          <mat-form-field class="example-full-width">
            <mat-label>Teléfono de contacto</mat-label>
            <input matInput [(ngModel)]="consultaGarantia.telefonoContacto" name="telefonoContacto"
              formControlName="vTelefonoContacto" minlength="3" maxlength="10" type="text"
              placeholder="Teléfono de contacto" required>
              @if (f.vTelefonoContacto.invalid) {
                <mat-error>
                  @if (f.vTelefonoContacto.hasError('required')) {
                    <div>
                      {{'El campo Teléfono de contacto es requerido'}}
                    </div>
                  }
                  @if (f.vTelefonoContacto.hasError('pattern')) {
                    <div>
                      {{'El campo Teléfono debe ser un número'}}
                    </div>
                  }
                  @if (f.vTelefonoContacto.hasError('minlength')) {
                    <div>
                      {{'El campo debe tener mínimo 3 carácteres'}}
                    </div>
                  }
                  @if (f.vTelefonoContacto.hasError('maxlength')) {
                    <div>
                      {{'El campo debe tener máximo 10 carácteres'}}
                    </div>
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-md-4 form-group">
            <mat-form-field class="example-full-width">
              <mat-label>Motivo de consulta</mat-label>
              <input matInput [(ngModel)]="consultaGarantia.motivoConsulta" name="motivoConsulta"
                formControlName="vMotivoConsulta" minlength="3" maxlength="50" type="text" placeholder="Motivo de consulta" required>
                @if (f.vMotivoConsulta.invalid) {
                  <mat-error>
                    @if (f.vMotivoConsulta.hasError('required')) {
                      <div>
                        {{'El campo Motivo de consulta es requerido'}}
                      </div>
                    }
                    @if (f.vMotivoConsulta.hasError('pattern')) {
                      <div>
                        {{'El campo Motivo de consulta no permite caracteres especiales'}}
                      </div>
                    }
                    @if (f.vMotivoConsulta.hasError('minlength')) {
                      <div>
                        {{'El campo debe tener mínimo 3 carácteres'}}
                      </div>
                    }
                    @if (f.vMotivoConsulta.hasError('maxlength')) {
                      <div>
                        {{'El campo debe tener máximo 50 carácteres'}}
                      </div>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-md-4 form-group">
              <mat-form-field class="example-full-width">
                <mat-label>Referencia de la garantía</mat-label>
                <input matInput [(ngModel)]="consultaGarantia.codigoGarantia" name="codigoGarantia"
                  formControlName="vCodigoGarantia" minlength="3" maxlength="7" (change)="toUpperCaseGarantia()" type="text" placeholder="Referencia de la garantía" required>
                  @if (f.vCodigoGarantia.invalid) {
                    <mat-error>
                      @if (f.vNumeroIdentificacion.hasError('pattern')) {
                        <div>
                          {{'El campo Referencia de la garantía no es valido'}}
                        </div>
                      }
                      @if (f.vCodigoGarantia.hasError('required')) {
                        <div>
                          {{'El campo Referencia de la garantía es requerido'}}
                        </div>
                      }
                      @if (f.vCodigoGarantia.hasError('minlength')) {
                        <div>
                          {{'El campo debe tener mínimo 3 carácteres'}}
                        </div>
                      }
                      @if (f.vCodigoGarantia.hasError('maxlength')) {
                        <div>
                          {{'El campo debe tener máximo 7 carácteres'}}
                        </div>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-4">
                <button disabled="{{form.invalid || loading}}" (click)="consultaGarantiaFun(!form.invalid)" mat-raised-button
                  style="background-color: #ed7326; color: white;" color="primary">
                  CONSULTAR GARANTÍA
                  <mat-icon style="margin-top: -19px;">send</mat-icon>
                </button>
              </div>

            </div>

          </form>

          @if (showResult) {
            <div>
              <div class="card">
                <div class="card-header" style="text-align: center;">
                  REFERENCIA No: {{response.garantia.referencia}}
                </div>
                <div class="card-body">
                  <h3 class="card-title">ORDENANTE</h3>
                  <div class="row">
                    <div class="col-md-6">
                      <label for="">Nombre</label>
                      <div class="form form-control">{{response.ordenante.nombre}}</div>
                    </div>
                    <div class="col-md-2">
                      <label for="">Tipo de identificación</label>
                      <div class="form form-control">{{response.ordenante.tipoIdentificacion}}</div>
                    </div>
                    <div class="col-md-2">
                      <label for="">Número de identificación</label>
                      <div class="form form-control">{{response.ordenante.numeroIdentificacion}}</div>
                    </div>
                    <div class="col-md-2">
                      <label for="">Dígito de verificación</label>
                      <div class="form form-control">{{response.ordenante.digitoVerificacion}}</div>
                    </div>
                  </div>
                  <h3 class="card-title">BENEFICIARIO</h3>
                  <div class="row">
                    <div class="col-md-6">
                      <label for="">Nombre</label>
                      <div class="form form-control">{{response.beneficiario.nombre}}</div>
                    </div>
                    <div class="col-md-2">
                      <label for="">Tipo de identificación</label>
                      <div class="form form-control">{{response.beneficiario.tipoIdentificacion}}</div>
                    </div>
                    <div class="col-md-2">
                      <label for="">Número de identificación</label>
                      <div class="form form-control">{{response.beneficiario.numeroIdentificacion}}</div>
                    </div>
                    <div class="col-md-2">
                      <label for="">Dígito de verificación</label>
                      <div class="form form-control">{{response.beneficiario.digitoVerificacion}}</div>
                    </div>
                  </div>
                  <h3 class="card-title">GARANTÍA</h3>
                  <div class="row">
                    <div class="col-md-4">
                      <label for="">Referencia</label>
                      <div class="form form-control">{{response.garantia.referencia}}</div>
                    </div>
                    <div class="col-md-4">
                      <label for="">Fecha de emisión</label>
                      <div class="form form-control">{{response.garantia.fechaEmision}}</div>
                    </div>
                    <div class="col-md-4">
                      <label for="">Fecha de vencimiento</label>
                      <div class="form form-control">{{response.garantia.fechaVencimiento}}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <label for="">Moneda</label>
                      <div class="form form-control">{{response.garantia.moneda}}</div>
                    </div>
                    <div class="col-md-4">
                      <label for="">Valor operación</label>
                      <div class="form form-control">{{response.garantia.valorOperacion}}</div>
                    </div>
                    <div class="col-md-4">
                      <label for="">Propósito de la garantía</label>
                      <div class="form form-control">{{response.garantia.propositoGarantia}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (showError) {
            <div>
              @for (alert of alerts; track alert) {
                <p>
                  <ngb-alert [type]="alert.type">
                    {{alert.message.messageTitle}}
                    <ul style="margin-left: 30px;">
                      @for (item of alert.message.items; track item) {
                        <li>{{item}}</li>
                      }
                    </ul>
                  {{alert.message.messageFoot}}</ngb-alert>
                </p>
              }
            </div>
          }
